<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part" id="part01"><a id="page_13"></a>PART 1: WHAT SECRECY MEANS</h2>
<p class="noindent"><a id="page_14"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?0fdb8de8